import { sendEventsToConversionAPI } from "../utils/service";
import ReactGA from "react-ga4";

export const sendMetaEvents = async (event_title) => {
  const res = await sendEventsToConversionAPI(event_title);
};

export const sendGoogleAnalyticsEvents = (eventDetails) => {
  ReactGA.event({
    ...eventDetails,
  });
};

export const checkEnvironemnt = () => {
  const URL =
    process.env.REACT_APP_CUSTOM_ENV === "production"
      ? "https://api.championschoice.co.uk"
      : "https://api-stag.championschoice.co.uk";
  return URL;
};

// True when a request failed (any non-2xx, or no response at all).
//
// Needed because utils/api.js swallows errors and returns a value either way,
// so `if (response)` cannot tell a 500 from real data - a 500 body is truthy.
// That is how a backend 500 rendered as "You currently have no active games"
// on the Dashboard: the failure was indistinguishable from an empty list.
//
// Use this to separate "we could not load" from "there is nothing here", and
// tell the player which one it is.
export const isApiError = (response) => Boolean(response && response.__apiError);
